export function getClassnames(bgStyle: 'light' | 'dark'): { bg: string; icon: string } {
  switch (bgStyle) {
    case 'light':
      return {
        bg: 'bg-white',
        icon: 'text-black-light group-hover:text-white',
      }

    case 'dark':
      return {
        bg: 'bg-black-light',
        icon: 'text-white',
      }

    default:
      return {
        bg: '',
        icon: '',
      }
  }
}
